/* eslint-disable radix */
import {
  concat, findIndex, insert, merge, propEq, reject
} from 'ramda';
import {
  LOAD_ALL_USER_RIGHT_FAIL,
  LOAD_ALL_USER_RIGHT_REQUEST,
  LOAD_ALL_USER_RIGHT_SUCCESS,
  LOAD_DEFAULT_USER_RIGHT_FAIL,
  LOAD_DEFAULT_USER_RIGHT_REQUEST,
  PUT_USER_RIGHT_FAIL,
  PUT_USER_RIGHT_REQUEST,
  PUT_USER_RIGHT_SUCCESS,
  POST_USER_RIGHT_FAIL,
  POST_USER_RIGHT_REQUEST,
  POST_USER_RIGHT_SUCCESS,
  SET_USER_RIGHT_GROUP,
  DELETE_USER_RIGHT_SUCCESS,
  DELETE_USER_RIGHT_REQUEST,
  DELETE_USER_RIGHT_FAIL,
  RESET_USER_RIGHT_DATA,
  RESET_USER_RIGHT_GROUP_INFO,
  SET_DEFAULT_USER_RIGHTS
} from 'src/store/actions/userRightActions';

const addOrReplaceInList = (group, prop, list) => (
  // concat([filter], reject(propEq(prop, filter[prop]), list)); // if it exists, then add it to the list but remove old value first.
  insert(findIndex(propEq(prop, group[prop]), list), group, reject(propEq(prop, group[prop]), list))
);

const initialState = {
  allGroupRights: [],
  options: [],
  selectedUserRightGroup: {},
  fetching: false,
  errors: [],
  defaultRights: {}
};

const rightsToOptions = (rights) => rights.map(({ Id, Name }) => ({ label: Name, value: `${Id}` }));

const userRightReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_ALL_USER_RIGHT_REQUEST:
      return merge(state, { fetching: true, allGroupRights: [], options: [] });
    case LOAD_ALL_USER_RIGHT_SUCCESS:
      return merge(state, {
        allGroupRights: action.data,
        options: rightsToOptions(action.data),
        fetching: false
      });
    case LOAD_ALL_USER_RIGHT_FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case LOAD_DEFAULT_USER_RIGHT_REQUEST:
      return merge(state, { fetching: true });
    case LOAD_DEFAULT_USER_RIGHT_FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case POST_USER_RIGHT_REQUEST:
      return merge(state, { fetching: true });
    case POST_USER_RIGHT_SUCCESS: {
      const newRights = concat(state.allGroupRights, [action.data]);
      return merge(state, {
        allGroupRights: newRights,
        options: rightsToOptions(newRights),
        fetching: false
      });
    }
    case POST_USER_RIGHT_FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case PUT_USER_RIGHT_REQUEST:
      return merge(state, { fetching: true });
    case PUT_USER_RIGHT_SUCCESS: {
      const newRights = addOrReplaceInList(action.data, 'Id', state.allGroupRights);
      return merge(state, {
        allGroupRights: newRights,
        options: rightsToOptions(newRights),
        fetching: false
      });
    }
    case PUT_USER_RIGHT_FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case DELETE_USER_RIGHT_REQUEST:
      return merge(state, { fetching: true });
    case DELETE_USER_RIGHT_SUCCESS: {
      const newRights = reject(propEq('Id', parseInt(action.groupId)), state.allGroupRights);
      return merge(state, {
        allGroupRights: newRights,
        options: rightsToOptions(newRights),
        fetching: false
      });
    }
    case DELETE_USER_RIGHT_FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case SET_USER_RIGHT_GROUP:
      return merge(state, { selectedUserRightGroup: action.data, fetching: false });
    case RESET_USER_RIGHT_DATA:
      return merge(state, initialState);
    case RESET_USER_RIGHT_GROUP_INFO:
      return merge(state, { selectedUserRightGroup: {} });
    case SET_DEFAULT_USER_RIGHTS:
      return merge(state, { defaultRights: action.data });

    default:
      return state;
  }
};


export default userRightReducer;
